


































































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
@Component
export default class extends AbpBase {
  importUrl: string = "";
  timer: any;
  signalrConn: any;
  msgList: any = [];
  sheetList: any = [
    "用户信息表",
    "病人基本信息表",
  ];
  payload: any = {
    sheetList: [],
  };

  created() {
    this.payload.sheetList = this.sheetList;
    this.importUrl = `${XMLHTTP_BASEURL}/api/services/app/ImportData/ImportInitialData`;
    this.timer = setInterval(() => {
      this.showMessage();
    }, 100);
  }

  destory() {
    this.timer = null;
    clearInterval(this.timer);
  }

  get headers() {
    return {
      "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie(),
      Authorization: "Bearer " + window.abp.auth.getToken(),
    };
  }

  get logHeight() {
    return window.innerHeight - 400;
  }

  isWarn(msg: string) {
    return msg && msg.indexOf("【WARN】") != -1;
  }

  isError(msg: string) {
    return msg && msg.indexOf("【ERROR】") != -1;
  }

  isDebug(msg: string) {
    return msg && msg.indexOf("【DEBUG】") != -1;
  }

  async showMessage() {
    let msg = await this.$store.dispatch({
      type: "signalr/popMessage",
      messageType: "初始数据导入日志",
    });
    if (msg) {
      this.msgList.splice(0, 0, {
        time: `${this.fmtDate(new Date(), "hh:mm:ss")}`,
        message: msg.MessageContent,
      });
    }
  }

  handleFormatError(file: any) {
    this.$Message.warning("请选择'xlsx'格式文件！");
  }

  handleBeforeUpload(res: any) {
    this.msgList.splice(0, 0, {
      time: `${this.fmtDate(new Date(), "hh:mm:ss")}`,
      message: "开始上传文件",
    });
  }

  async downloadTemplate() {
    let url = `${XMLHTTP_BASEURL}Templates/慢病标准版初始数据导入模板.xlsx`;
    window.open(url);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/importData/index.vue